import { Component } from '@angular/core';
import { BaseService } from '../../service/base.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-release-notes',
  templateUrl: './release-notes.component.html',
  styleUrls: ['./release-notes.component.scss'],
})
export class ReleaseNotesComponent {
  modules;
  versionNumber = '1.1.2';

  constructor(
    private _baseService: BaseService,
    public _translate: TranslateService,
    private dialogRef: MatDialogRef<ReleaseNotesComponent>
  ) {
    this._baseService.get('api/v1/module/version').subscribe((res) => {
      this.modules = res.data;
    });
  }
}
